import React from "react"
import ReactModal from "react-modal"
import PropTypes from "prop-types"
import USD from "../usd"
import { calculateCart } from "../../shop/common"

const ItemButton = (props) => (
  <div className="open-orders-list__item" onClick={props.onClick.bind(null, props.item.id)}>
    <div className="open-orders-list__item--title">{props.item.name}</div>
    <div className="open-orders-list__item--footer">
      <div className="pull-right">
        <span className="fa fa-clock-o">&nbsp;</span>
        {durationFromNow(props.item.createdAt)}
      </div>
      <USD val={calculateCart(props.item, props.products).totalPrice}/>
    </div>
  </div>
)

const durationFromNow = time => {
  const minutes = Math.floor(((new Date()).getTime() - (new Date(time)).getTime()) / 60000)
  const hours = Math.floor(minutes / 60)
  return (hours ? `${hours}hr ` : "") + `${minutes % 60}m`
}

const OpenOrdersListModal = props => {
  const contentStyle = {}
  if (props.sortedItemIds.length > 4) contentStyle.height = "404px"
  if (props.sortedItemIds.length > 8) {
    contentStyle.height = "574px"
    contentStyle.top = "100px"
  }
  const items = props.sortedItemIds.map(id => props.items[id]).filter(el => el.shopId === props.currentShop.id)
  return (
    <ReactModal style={{content: contentStyle}} isOpen={props.isOpen} className="open-orders-list-modal"
      onRequestClose={props.onRequestClose} contentLabel="Open Orders List Modal">
      <div className="open-orders-list">
        {items.map(item =>
          <ItemButton key={item.id} item={item} products={props.products} onClick={props.onClickItem}/>
        )}
      </div>
      <button className="open-order-delete-all" onClick={props.onClickDelete}>Delete All</button>
    </ReactModal>
  )
}

OpenOrdersListModal.propTypes = {
  isOpen: PropTypes.bool,
  items: PropTypes.object,
  onClickItem: PropTypes.func,
  onRequestClose: PropTypes.func,
  products: PropTypes.object,
  sortedItemIds: PropTypes.array
}

export default OpenOrdersListModal

